<template>
    <div class="line">
        <div ref="linechart" class="linechart" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false">
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope109",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            title: "三组基本折线图-scope103-日期选择器",
            timer: null,
            defaultdata: [
                {
                    value1: "1月",
                    value2: "80",
                    value3: "系列一",
                    value4: "60",
                    value5: "系列二",
                    value6: "80",
                    value7: "系列三",
                    value8: "天数",
                },
                {
                    value1: "2月",
                    value2: "40",
                    value3: "系列一",
                    value4: "40",
                    value5: "系列二",
                    value6: "50",
                    value7: "系列三",
                },
                {
                    value1: "3月",
                    value2: "62",
                    value3: "系列一",
                    value4: "70",
                    value5: "系列二",
                    value6: "70",
                    value7: "系列三",
                },
                {
                    value1: "4月",
                    value2: "90",
                    value3: "系列一",
                    value4: "20",
                    value5: "系列二",
                    value6: "30",
                    value7: "系列三",
                },
                {
                    value1: "5月",
                    value2: "62",
                    value3: "系列一",
                    value4: "30",
                    value5: "系列二",
                    value6: "30",
                    value7: "系列三",
                },
                {
                    value1: "6月",
                    value2: "60",
                    value3: "系列一",
                    value4: "50",
                    value5: "系列二",
                    value6: "20",
                    value7: "系列三",
                },
                {
                    value1: "7月",
                    value2: "40",
                    value3: "系列一",
                    value4: "60",
                    value5: "系列二",
                    value6: "60",
                    value7: "系列三",
                },
                {
                    value1: "8月",
                    value2: "50",
                    value3: "系列一",
                    value4: "70",
                    value5: "系列二",
                    value6: "90",
                    value7: "系列三",
                },
                {
                    value1: "9月",
                    value2: "50",
                    value3: "系列一",
                    value4: "70",
                    value5: "系列二",
                    value6: "90",
                    value7: "系列三",
                },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "折线图数值1", key: "value2" },
                { name: "折线图图例1", key: "value3" },
                { name: "折线图数值2", key: "value4" },
                { name: "折线图图例2", key: "value5" },
                { name: "折线图数值3", key: "value6" },
                { name: "折线图图例3", key: "value7" },
                { name: "单位", key: "value8" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            config: {},
            iscontact: false,
            autoTimePaused: false,
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n.filter(
                    (item) => item && item[this.valueMap[0].key]
                );
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.DrawEcharts();
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        ...methods,
        DrawEcharts() {
            clearInterval(this.timer);
            this.timer = null;
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.linechart);
            let data1 = [];
            let data2 = [];
            let data3 = [];
            let legend1 = [];
            this.defaultdata.forEach((item, i) => {
                if (item.value2 && item.value3) {
                    const vdata1 = { name: item.value3, value: item.value2 };
                    data1.push(vdata1);
                }
                if (item.value4 && item.value5) {
                    const vdata2 = { name: item.value5, value: item.value4 };
                    data2.push(vdata2);
                }
                if (item.value6 && item.value7) {
                    const vdata3 = { name: item.value7, value: item.value6 };
                    data3.push(vdata3);
                }

                if (i == 0) {
                    if (item.value2) {
                        legend1.push(item.value3);
                    }

                    if (item.value4) {
                        legend1.push(item.value5);
                    }

                    if (item.value6) {
                        legend1.push(item.value7);
                    }
                }
            });
            const legend = {
                show: true,
                top: "2%",
                // left: "50%",
                itemHeight: 12, //图例的高度  文字左边那个
                itemWidth: 10,
                itemGap: 10, // 设置图例项之间的间隔
                icon: "rect",
                textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                data: legend1,
            };
            const xAxis = this.defaultdata.map((item) => item.value1);
            const percent = (7 / xAxis.length) * 100;
            let onepercent = (1 / xAxis.length) * 100;
            let zoom = [
                {
                    id: "scope109", // 唯一的idtype: 'slider',
                    moveHandleSize: 0,
                    showDetail: false, //关闭：拖拽时候显示详细数值信息。	
                    dataBackground: {
                        show: false,
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    selectedDataBackground: {
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    bottom: 20,
                    backgroundColor: "transparent",
                    fillerColor: "rgba(0,0,0,.2)",
                    borderColor: "transparent",
                    start: 0,
                    brushSelect: false,
                    end: percent
                },
            ];
            var Toption = {
                title: [
                    {
                        text: this.defaultdata[0].value8 || '',
                        top: "0",
                        left: "0",
                        textStyle: {
                            color: "#979AA0",
                            fontSize: 12,
                        },
                    },
                ],
                tooltip: {
                    trigger: "axis",
                },
                grid: {
                    left: "5px",
                    right: "10px",
                    bottom: "0px",
                    top: "40px",
                    containLabel: true,
                },

                legend,
                xAxis: {
                    type: "category",
                    axisTick: {
                        show: false,
                    },
                    boundaryGap: false,
                    axisLabel: {
                        rotate: 45,
                        interval: 0,
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                            fontSize: "10",
                            lineHeight: 10,
                        },
                    },
                    axisPointer: {
                        type: "shadow",
                    },
                    axisLine: {
                        lineStyle: {
                            // X 轴颜色配置
                            color: "#4792e9",
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                    data: this.defaultdata.map((item) => item.value1),
                },
                yAxis: {
                    type: "value",
                    splitNumber: 2,
                    axisLabel: {
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为灰白色
                        },
                        fontSize: 14,
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                },
                series: [
                    {
                        name: this.defaultdata[0].value3 || "",
                        type: "line",
                        showSymbol: true,
                        symbol: "circle",
                        symbolSize: 8,
                        symbolOffset: [0, "8%"],
                        lineStyle: {
                            color: "#3880F3",
                            width: 2,
                        },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: "#0182fc", // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: "#0182fc", // 0% 处的颜色
                                        },
                                    ],
                                    false
                                ),
                            },
                        },
                        data: data1,
                    },
                    {
                        name: this.defaultdata[0].value5 || "",
                        type: "line",
                        showSymbol: true,
                        symbol: "circle",
                        symbolSize: 8,
                        symbolOffset: [0, "8%"],
                        lineStyle: {
                            color: "#04eaea",
                            width: 2,
                        },
                        itemStyle: {
                            normal: {
                                color: "#05ffff", // 0% 处的颜色
                            },
                        },
                        data: data2,
                    },
                    {
                        name: this.defaultdata[0].value7 || "",
                        type: "line",
                        showSymbol: true,
                        symbol: "circle",
                        symbolSize: 8,
                        symbolOffset: [0, "8%"],
                        lineStyle: {
                            color: "#ff6561",
                            width: 2,
                        },
                        itemStyle: {
                            normal: {
                                color: "#ff6561", // 0% 处的颜色
                            },
                        },
                        data: data3,
                    },
                ],
                dataZoom: xAxis.length > 7 ? zoom : [],
            };
            TmyChart.clear();
            Toption && TmyChart.setOption(Toption);
            if (xAxis.length > 7) {
                let i = xAxis.length - 7
                let aindex = 1
                this.timer = setInterval(() => {
                    if (this.autoTimePaused) return
                    TmyChart.dispatchAction({
                        type: 'dataZoom',
                        start: aindex * onepercent,
                        end: (aindex * onepercent + percent)
                    });
                    if (aindex == i) {
                        aindex = 0
                    } else {
                        aindex += 1
                    }
                }, 3000)
            } else {
                let timers = this.getRandomInt(25, 35)
                this.timer = setInterval(() => {
                    if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                    TmyChart.clear();
                    Toption && TmyChart.setOption(Toption);
                }, timers * 1000);
            }
        },
    },
    created() { },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata.filter((item) => item && item[this.valueMap[0].key])
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.DrawEcharts(); //需要刷新的数据
    },
};
</script>

<style scoped>
.line {
    width: 435px;
    height: 240px;
    display: flex;
    position: relative;
    overflow: hidden;
    padding: 10px 0;
}

.linechart {
    width: 100%;
    height: 100%;
}
</style>